import { render, staticRenderFns } from "./AskSetting.vue?vue&type=template&id=4606fdb0&scoped=true&"
import script from "./AskSetting.vue?vue&type=script&lang=js&"
export * from "./AskSetting.vue?vue&type=script&lang=js&"
import style0 from "./AskSetting.vue?vue&type=style&index=0&id=4606fdb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606fdb0",
  null
  
)

export default component.exports